import { useNavigate } from 'react-router-dom'

import ArrowIcon from 'assets/icons/ArrowRight.png'
import DownloadIcon from 'assets/icons/download.svg'
import { Button } from 'components/Button'

import { AssessmentTabs } from './AssessmentTabs'
import { DimensionCards } from './DimensionCards'
import './brandAssessment.scss'

export const BrandAssessment = () => {
  const navigate = useNavigate()
  const downloadUrl =
    'https://facade-api.dev.mos.coke.com/v3/download-file/bucket/facade-bucketstandarbackendstack-facade-development/bva%2F2026%2FbrandAssessment.pptx'

  const handleDownload = async () => {
    try {
      const res = await fetch(downloadUrl, { credentials: 'include' })
      if (!res.ok) throw new Error('Network response was not ok')
      const blob = await res.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = 'Brand assessment.pptx'
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      window.open(downloadUrl, '_blank', 'noopener')
    }
  }

  return (
    <div className="brand-assessment mx-auto">
      <div className="brand-assessment-intro">
        <h1 className="headline-xxl text-center">Brand Assessment</h1>
        <div className="flex flex-col items-center gap-4">
          <p className="body-m font-bold text-center">
            Before embarking on your Brand Vision Architecture journey, it's essential to conduct a brand assessment to
            get specific on your brand's current position and needs.
          </p>
          <p className="body-m text-center">
            This isn't an in-depth assessment (your brand already underwent one during LRP/ABP), but rather a quick
            temperature check to guide your next steps.
          </p>
          <p className="body-m text-center">
            This audit will help determine if you need a{' '}
            <span className="font-bold">
              complete BVA development, a focused refresh of specific elements, or simple adjustments
            </span>{' '}
            to align with the new framework. Even in cases where you're updating select components,{' '}
            <span className="font-bold">all aspects of the BVA should be briefly reviewed</span> to ensure cohesion and
            alignment.
          </p>
          <p className="body-m text-center">
            For guidance on conducting your BVA assessment, please refer to the information below and complete the Brand
            Assessment document for your brand.
          </p>
          <div className="brand-assessment-download">
            <Button
              text="Download document"
              color="white"
              className="px-[16px] py-[10px] border-2"
              icon={<img src={DownloadIcon} alt="Download" className="ml-2" width="16" height="16" />}
              onClick={handleDownload}
            />
          </div>
        </div>
      </div>

      {/* <div className=""> */}
      <DimensionCards />
      {/* </div> */}

      <AssessmentTabs />

      <div className="flex justify-center">
        <Button
          text="Go to Project Setup"
          color="black"
          icon={<img src={ArrowIcon} alt="Arrow" className="ml-2" width="16" height="16" />}
          className="px-[16px] py-[10px] z-[2]"
          onClick={() => navigate('/process?Project Set-Up')}
        />
      </div>
    </div>
  )
}
